import { registerColors } from './colors';

export const inputBorderSx = {
  '& .MuiOutlinedInput-root': {
    '& fieldset': { borderColor: registerColors.borderSubtle },
    '&:hover fieldset': { borderColor: registerColors.borderSubtle },
  },
};
